import {
  type TextFieldProps,
  TextField as MuiTextField,
  InputLabel,
  Box,
  type SxProps,
  type Theme,
} from '@mui/material'
import { type ForwardedRef, forwardRef } from 'react'

interface ExtraTextFieldProps {
  subLabel?: React.ReactNode
  bottomContent?: React.ReactNode
  containerStyle?: SxProps<Theme>
}

export const TextField = forwardRef(
  (
    {
      label,
      required,
      name,
      bottomContent,
      containerStyle,
      ...otherProps
    }: TextFieldProps & ExtraTextFieldProps,
    ref: ForwardedRef<HTMLDivElement>
  ) => {
    return (
      <Box sx={containerStyle}>
        {label && (
          <InputLabel required={required} htmlFor={name}>
            {label}
          </InputLabel>
        )}
        <MuiTextField
          fullWidth={true}
          variant="outlined"
          id={name}
          name={name}
          ref={ref}
          sx={{ maxWidth: 'none' }}
          {...otherProps}
        />
        {bottomContent}
      </Box>
    )
  }
)

TextField.displayName = 'TextField'
